import { DateTime } from 'luxon'
import { ThunkAction } from 'redux-thunk'


import config from 'admin/config/main'
import { reduxDependenciesType } from 'admin/redux/create'
import { State } from 'admin/redux/ducks'
import { TransactionsListType, TransactionSummaryType } from 'admin/types'
import { TransactionsParamsType } from 'admin/types/api'
import createApiReducer, {
  requestDataFor,
  receiveDataFor,
  handleErrorFor,
} from 'redux/utils/createApiDuck'
import DateUtil, { formats } from 'services/dateUtil'
import { APIState } from 'types'

const moduleName = `${config.appName  }/transactions`

export default createApiReducer(moduleName)

/**
 *
 * @param orgAccountId
 * @param params The date filter sets the time in from date to 00.00.00.00
 * and the time in to date to 23.59.59.999
 */
export function fetchTransactionsWholeDay(
  orgAccountId: string,
  params?: TransactionsParamsType,
): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return (dispatch, getState, { api }) => {
    dispatch(requestDataFor(moduleName)())

    let fromDate: string;
    let toDate: string;

    if (params.filters['filter-trans-from']) {
      const filterTransFrom: string = params.filters['filter-trans-from'];
      const dateTimeTransFrom: DateTime = DateTime.fromString(filterTransFrom, formats.SIMPLE);
      const swedenTransFrom: DateTime = DateUtil.getSweDateTimeFromISO(dateTimeTransFrom.startOf('day').toISO());
      fromDate = swedenTransFrom.toJSDate().toISOString();
    } else {
      fromDate = params.filters['filter-trans-from']
    }

    if (params.filters['filter-trans-to']) {
      const filterTransTo: string = params.filters['filter-trans-to']; 
      const dateTimeTransTo: DateTime = DateTime.fromString(filterTransTo, formats.SIMPLE);
      const swedenTransTo: DateTime = DateUtil.getSweDateTimeFromISO(dateTimeTransTo.endOf('day').toISO());
      toDate = swedenTransTo.toJSDate().toISOString();
    } else {
      toDate = params.filters['filter-trans-to']
    }

    const filters = { ...params.filters, 'filter-trans-from': fromDate,
      'filter-trans-to': toDate,}

    const paramsUpdated = { ...params, ...{
      filters,
    } as TransactionsParamsType}

    return api
      .getTransactions(orgAccountId, paramsUpdated)
      .then((data: TransactionsListType) => {
        const enrichedData: TransactionsListType = {
          ...data,
          pagesTotal: Math.ceil(data.totalNumberFiltered / params.limit),
        }
        dispatch(receiveDataFor(moduleName)(enrichedData))
        return enrichedData
      })
      .catch(error => dispatch(handleErrorFor(moduleName)(error)))
  }
}
/**
 * Batch fetch all transactions for given filter parameter, but unpaged
 * */
export function fetchAllTransactionsAction(
  orgAccountId: string,
  startParams?: TransactionsParamsType,
): ThunkAction<Promise<any>, State, reduxDependenciesType> {
  return async (dispatch, getState, { api }) => {
    const params: TransactionsParamsType = {
      ...startParams,
      offset: 0,
      limit: 1000,
    }
    let result: TransactionsListType
    let transactions: TransactionSummaryType[] = []
    try {
      do {
        result = (await api.getTransactions(
          orgAccountId,
          params,
        )) as TransactionsListType
        transactions = transactions.concat(
          (result as TransactionsListType).transactions,
        )
        params.offset += params.limit
      } while (result.transactions.length > 0)
    } catch (error) {
      return error
    }
    return transactions
  }
}

export interface TransactionsState extends APIState {
  data: TransactionsListType
}
